










import { KpiEnum } from '../../enums';

import CheckboxGroup from '../checkbox-group.component.vue';

export default {
  name: 'kpis-legend',
  components: {
    CheckboxGroup
  },
  props: {
    value: Array,
    items: {
      type: Array,
      default: () => []
    },
    multiSelect: {
      type: Boolean,
      default: true
    },
    vertical: Boolean
  },
  methods: {
    onKpiChange: function (selectedKpis: KpiEnum[]): void {
      this.$emit('input', selectedKpis);
    }
  }
};
